import "./AdditionalNotesSection.css";
import { useId } from "react";


function AdditionalNotesSection({ textValue, handleTextValueChange, id, name, maxLength=1000, placeholder="상담내용을 입력해 주세요"}) {
    const reactId = useId();
    const inputId = id || name || `textarea-${reactId}`;

    return (
        <div className="additional-notes">
            <label htmlFor={inputId}>상담내용</label>
            <textarea
                id={inputId}
                name={name || inputId}
                rows="8"
                value={textValue}
                onChange={handleTextValueChange}
                placeholder={placeholder}
                maxLength={maxLength}
            />
        </div>
    );
}

export default AdditionalNotesSection;